module.exports = __webpack_public_path__ + "media/src/images/proctored_icons/word-ff941a1635603384a258e866f8942bd6.svg";